import React from "react";
import styled from "styled-components";

import { Container, PortalBackground } from "../../../components";
import { BREAKPOINT, COLOR } from "../../../components/theme";

const MAX_WIDTH_DESKTOP = "730px";

const PADDING_DESKTOP = "24px 20px";
const PADDING_MOBILE = "15px 20px ";

const CONTAINER_MARGIN = "20px 0";
const BUTTON_MARGIN = "15px 15px 0 0";

const ContentWrapper = styled.div`
  max-width: ${BREAKPOINT.SIZE_DESKTOP};
  width: 100%;
  margin-top: 50px;
  border-radius: 6px;
  @media screen and (max-width: ${BREAKPOINT.SIZE_MOBILE}) {
    margin: 0;
  }
`;

const FullWidthContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: ${CONTAINER_MARGIN};
  max-width: ${MAX_WIDTH_DESKTOP};

  > div {
    background: ${COLOR.GREY};
    width: 100%;
    padding: ${PADDING_MOBILE};

    &:first-of-type {
      padding-bottom: 0;
    }
  }

  @media screen and (min-width: ${BREAKPOINT.SIZE_MOBILE}) {
    flex-wrap: nowrap;

    > div {
      padding: ${PADDING_DESKTOP};
    }
  }

  button {
    margin: ${BUTTON_MARGIN};
    width: 100%;

    @media screen and (min-width: ${BREAKPOINT.SIZE_MOBILE}) {
      width: auto;
    }
  }
`;

const Scene = ({ children }) => (
  <>
    <PortalBackground>
      <ContentWrapper>
        <Container rounded bg="white" padding="4">
          {children}
        </Container>
      </ContentWrapper>
    </PortalBackground>
  </>
);

Scene.FullWidth = FullWidthContainer;

export default Scene;
